import logger from "./logger";

/**
 * 機器人回覆完成時顯示瀏覽器通知（需使用者已授權通知權限）
 * @param {string} [previewText] - 回覆內容預覽，過長會截斷
 */
export function showReplyNotification(previewText = '') {
  if (typeof window === 'undefined' || !window.Notification) {
    logger.warn("Notification", "window.Notification is not defined");
    return;
  }
  if (Notification.permission !== 'granted') {
    logger.warn("Notification", "Notification.permission is not granted");
    return; 
  }

  const title = 'MyBro';
  const body = previewText
    ? (previewText.length > 80 ? previewText.slice(0, 80) + '…' : previewText)
    : '機器人已回覆';

  try {
    const n = new Notification(title, {
      body,
      icon: '/favicon.ico',
    });
    n.onclick = () => {
      window.focus();
      n.close();
    };
    // 自動關閉，避免堆積
    setTimeout(() => n.close(), 5000);
  } catch (err) {
    console.warn('顯示通知失敗', err);
  }
}
